import Typography from '@material-ui/core/Typography'
import styled from 'styled-components'

export const SmallFontBlock = styled(Typography).attrs({
    variant: "body2",
    color: "textSecondary",
    component: "p"
})`
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 10px;
`
